import type { DefaultTranslationsObject, Language } from '../types.js'

export const hyTranslations: DefaultTranslationsObject = {
  authentication: {
    account: 'Հաշիվ',
    accountOfCurrentUser: 'Ընթացիկ օգտատիրոջ հաշիվ',
    accountVerified: 'Հաշիվը հաջողությամբ ստուգվել է։',
    alreadyActivated: 'Արդեն ակտիվացված է',
    alreadyLoggedIn: 'Արդեն մուտք եք գործել',
    apiKey: 'API բանալի',
    authenticated: 'Հաստատված',
    backToLogin: 'Վերադառնալ մուտքի էջ',
    beginCreateFirstUser: 'Սկսելու համար ստեղծեք Ձեր առաջին օգտահաշիվը',
    changePassword: 'Փոխել գաղտնաբառը',
    checkYourEmailForPasswordReset:
      'Եթե էլ. փոստի հասցեն կապված է հաշվի հետ, Դուք կարճ ժամանակում կստանաք գաղտնաբառը վերականգնելու հրահանգներ։ Խնդրում ենք ստուգել Ձեր սպամ կամ անցանկալի փոստի թղթապանակը, եթե էլ. նամակը մուտքի արկղում չէ։',
    confirmGeneration: 'Հաստատել ստեղծումը',
    confirmPassword: 'Հաստատել գաղտնաբառը',
    createFirstUser: 'Ստեղծել առաջին օգտահաշիվը',
    emailNotValid: 'Տրամադրված էլ. փոստը վավեր չէ',
    emailOrUsername: 'Էլ. փոստ կամ օգտանուն',
    emailSent: 'Էլ. նամակն ուղարկված է',
    emailVerified: 'Էլ. փոստը հաջողությամբ ստուգվել է։',
    enableAPIKey: 'Միացնել API բանալին',
    failedToUnlock: 'Չհաջողվեց բացել',
    forceUnlock: 'Հարկադրաբար բացել',
    forgotPassword: 'Մոռացե՞լ եք գաղտնաբառը',
    forgotPasswordEmailInstructions:
      'Խնդրում ենք մուտքագրել Ձեր էլ. փոստը։ Դուք կստանաք էլ. նամակ՝ գաղտնաբառը վերականգնելու հրահանգներով։',
    forgotPasswordQuestion: 'Մոռացե՞լ եք գաղտնաբառը։',
    forgotPasswordUsernameInstructions:
      'Խնդրում ենք ներքևում մուտքագրել Ձեր օգտանունը։ Գաղտնաբառը վերականգնելու հրահանգները կուղարկվեն Ձեր օգտանվան հետ կապված էլ. փոստի հասցեին։',
    generate: 'Ստեղծել',
    generateNewAPIKey: 'Ստեղծել նոր API բանալի',
    generatingNewAPIKeyWillInvalidate:
      'Նոր API բանալու ստեղծումը <1>անվավեր կդարձնի</1> նախորդ բանալին։ Համոզվա՞ծ եք, որ ցանկանում եք շարունակել։',
    lockUntil: 'Կողպել մինչև',
    logBackIn: 'Կրկին մուտք գործել',
    loggedIn: 'Այլ օգտանվամբ մուտք գործելու համար նախ <0>դուրս եկեք</0>։',
    loggedInChangePassword:
      'Գաղտնաբառը փոխելու համար գնացեք Ձեր <0>հաշիվ</0> և այնտեղ խմբագրեք Ձեր գաղտնաբառը։',
    loggedOutInactivity: 'Դուք դուրս եք եկել անգործության պատճառով։',
    loggedOutSuccessfully: 'Դուք հաջողությամբ դուրս եք եկել համակարգից։',
    loggingOut: 'Դուրս է գալիս...',
    login: 'Մուտք',
    loginAttempts: 'Մուտքի փորձեր',
    loginUser: 'Մուտք գործել օգտատիրոջ համար',
    loginWithAnotherUser: 'Այլ օգտանվամբ մուտք գործելու համար նախ <0>դուրս եկեք</0>։',
    logOut: 'Դուրս գալ',
    logout: 'Դուրս գալ',
    logoutSuccessful: 'Հաջողությամբ դուրս եք եկել։',
    logoutUser: 'Դուրս բերել օգտատիրոջը համակարգից',
    newAccountCreated:
      'Ձեզ համար նոր հաշիվ է ստեղծվել <a href="{{serverURL}}">{{serverURL}}</a> հասցեով մուտք գործելու համար։ Խնդրում ենք սեղմել հետևյալ հղման վրա կամ պատճենել ստորև նշված URL-ը բրաուզերում Ձեր էլ. փոստը հաստատելու համար՝ <a href="{{verificationURL}}">{{verificationURL}}</a><br> Էլ. փոստը հաստատելուց հետո Դուք կկարողանաք հաջողությամբ մուտք գործել։',
    newAPIKeyGenerated: 'Նոր API բանալի ստեղծվել է։',
    newPassword: 'Նոր գաղտնաբառ',
    passed: 'Հաստատված է',
    passwordResetSuccessfully: 'Գաղտնաբառը հաջողությամբ վերականգնվել է։',
    resetPassword: 'Վերականգնել գաղտնաբառը',
    resetPasswordExpiration: 'Գաղտնաբառի վերականգնման ժամկետի ավարտ',
    resetPasswordToken: 'Գաղտնաբառի վերականգնման թոքեն',
    resetYourPassword: 'Վերականգնել Ձեր գաղտնաբառը',
    stayLoggedIn: 'Մնալ համակարգում',
    successfullyRegisteredFirstUser: 'Առաջին օգտահաշիվը հաջողությամբ գրանցվել է։',
    successfullyUnlocked: 'Հաջողությամբ բացվել է',
    tokenRefreshSuccessful: 'Թոքենի թարմացումը հաջողվել է։',
    unableToVerify: 'Հնարավոր չէ հաստատել',
    username: 'Օգտանուն',
    usernameNotValid: 'Տրամադրված օգտանունը վավեր չէ',
    verified: 'Ստուգված',
    verifiedSuccessfully: 'Հաջողությամբ ստուգված',
    verify: 'Ստուգել',
    verifyUser: 'Ստուգել օգտահաշիվը',
    verifyYourEmail: 'Հաստատեք Ձեր էլ. փոստը',
    youAreInactive:
      'Ձեր հաշիվը որոշ ժամանակ անգործ է եղել և համակարգը ձեզ շուտով ինքնաբերաբար դուրս կհանի Ձեր իսկ անվտանգության համար։ Ցանկանու՞մ եք մնալ համակարգում։',
    youAreReceivingResetPassword:
      'Դուք ստացել եք սա, քանի որ Դուք (կամ ինչ-որ մեկը) խնդրել եք վերականգնել Ձեր հաշվի գաղտնաբառը։ Խնդրում ենք սեղմել հետևյալ հղման վրա կամ պատճենել այն բրաուզերում՝ գործընթացը ավարտելու համար։',
    youDidNotRequestPassword:
      'Եթե Դուք չեք ուղարկել հարցումը, խնդրում ենք անտեսել այս էլ. նամակը, և Ձեր գաղտնաբառը կմնա անփոփոխ։',
  },
  error: {
    accountAlreadyActivated: 'Այս հաշիվն արդեն ակտիվացված է։',
    autosaving: 'Այս փաստաթղթի ավտոմատ պահպանման ժամանակ խնդիր է առաջացել։',
    correctInvalidFields: 'Խնդրում ենք ուղղել անվավեր դաշտերը։',
    deletingFile: 'Ֆայլը ջնջելու ժամանակ սխալ է տեղի ունեցել։',
    deletingTitle:
      '{{title}}-ը ջնջելու ժամանակ սխալ է տեղի ունեցել։ Խնդրում ենք ստուգել Ձեր կապը և կրկին փորձել։',
    documentNotFound:
      'Գրառումը ID-ով {{id}} չի գտնվել։ Այն կարող է ջնջվել կամ նույնիսկ էլ գոյություն չունել։ Ֆո',
    emailOrPasswordIncorrect: 'Տրամադրված էլ. փոստը կամ գաղտնաբառը սխալ է։',
    followingFieldsInvalid_one: 'Հետևյալ դաշտն անվավեր է։',
    followingFieldsInvalid_other: 'Հետևյալ դաշտերն անվավեր են։',
    incorrectCollection: 'Սխալ հավաքածու',
    insufficientClipboardPermissions:
      'Սեղմատախտակին հասանելիությունը մերժվել է։ Խնդրում ենք ստուգել ձեր սեղմատախտակի թույլտվությունները։',
    invalidClipboardData: 'Անվավեր սեղմատախտակի տվյալներ։',
    invalidFileType: 'Անվավեր ֆայլի տեսակ',
    invalidFileTypeValue: 'Անվավեր ֆայլի տեսակ՝ {{value}}',
    invalidRequestArgs: 'Հայտում փոխանցված անվավեր արգումենտներ՝ {{args}}',
    loadingDocument: '{{id}} ID-ով փաստաթուղթը բեռնելու ժամանակ խնդիր է առաջացել։',
    localesNotSaved_one: 'Հետևյալ լոկալը չի պահպանվել։',
    localesNotSaved_other: 'Հետևյալ լոկալները չեն պահպանվել։',
    logoutFailed: 'Դուրս գալը ձախողվել է։',
    missingEmail: 'Էլ. փոստը բացակայում է։',
    missingIDOfDocument: 'Թարմացման համար փաստաթղթի ID-ն բացակայում է։',
    missingIDOfVersion: 'Տարբերակի ID-ն բացակայում է։',
    missingRequiredData: 'Պահանջվող տվյալները բացակայում են։',
    noFilesUploaded: 'Ֆայլեր չեն վերբեռնվել։',
    noMatchedField: '"{{label}}"-ի համար համապատասխան դաշտ չի գտնվել',
    notAllowedToAccessPage: 'Ձեզ թույլ չի տրվում մուտք գործել այս էջ։',
    notAllowedToPerformAction: 'Ձեզ թույլ չի տրվում կատարել այս գործողությունը։',
    notFound: 'Հայցված ռեսուրսը չի գտնվել։',
    noUser: 'Օգտատեր չկա',
    previewing: 'Այս փաստաթուղթը նախադիտելու ժամանակ խնդիր է առաջացել։',
    problemUploadingFile: 'Ֆայլը վերբեռնելու ժամանակ խնդիր է առաջացել։',
    restoringTitle:
      'Սխալ է տեղի ունեցել {{title}}-ի վերականգնելիս: Խնդրում ենք ստուգել ձեր կապը և կրկին փորձել:',
    tokenInvalidOrExpired: 'Թոքենն անվավեր է կամ ժամկետանց։',
    tokenNotProvided: 'Թոքենը տրամադրված չէ։',
    unableToCopy: 'Չհաջողվեց պատճենել։',
    unableToDeleteCount: 'Հնարավոր չէ ջնջել {{count}}-ը {{total}} {{label}}-ից։',
    unableToReindexCollection:
      'Հավաքածու {{collection}}-ը վերաինդեքսավորելու սխալ։ Գործողությունն ընդհատվել է։',
    unableToUpdateCount: 'Հնարավոր չէ թարմացնել {{count}}-ը {{total}} {{label}}-ից։',
    unauthorized: 'Չթույլատրված, Դուք պետք է մուտք գործեք այս հարցումը կատարելու համար։',
    unauthorizedAdmin: 'Չթույլատրված, այս օգտատերը հասանելություն չունի կառավարման վահանակ։',
    unknown: 'Անհայտ սխալ է տեղի ունեցել։',
    unPublishingDocument: 'Այս փաստաթուղթը չհրապարակված դարձնելու ժամանակ խնդիր է առաջացել։',
    unspecific: 'Սխալ է տեղի ունեցել։',
    unverifiedEmail: 'Խնդրում ենք հաստատել Ձեր էլ. փոստը նախքան մուտք գործելը։',
    userEmailAlreadyRegistered: 'Տվյալ էլ. փոստով օգտատեր արդեն գրանցված է։',
    userLocked: 'Այս օգտանունը կողպված է՝ մուտքի բազմաթիվ անհաջող փորձերի պատճառով։',
    usernameAlreadyRegistered: 'Տվյալ օգտանվամբ օգտատեր արդեն գրանցված է։',
    usernameOrPasswordIncorrect: 'Տրամադրված օգտանունը կամ գաղտնաբառը սխալ է։',
    valueMustBeUnique: 'Արժեքը պետք է եզակի լինի',
    verificationTokenInvalid: 'Ստուգման թոքենն անվավեր է։',
  },
  fields: {
    addLabel: 'Ավելացնել {{label}}',
    addLink: 'Ավելացնել հղում',
    addNew: 'Ավելացնել նոր',
    addNewLabel: 'Ավելացնել նոր {{label}}',
    addRelationship: 'Ավելացնել հարաբերություն',
    addUpload: 'Վերբեռնել',
    block: 'բլոկ',
    blocks: 'բլոկներ',
    blockType: 'Բլոկի տեսակ',
    chooseBetweenCustomTextOrDocument:
      'Ընտրեք՝ մուտքագրել հատուկ տեքստային URL, թե՞ կապել այլ փաստաթղթի հետ։',
    chooseDocumentToLink: 'Ընտրեք կապակցվելիք փաստաթուղթը',
    chooseFromExisting: 'Ընտրեք գոյություն ունեցողներից',
    chooseLabel: 'Ընտրեք {{label}}',
    collapseAll: 'Փակել բոլորը',
    customURL: 'Հատուկ URL',
    editLabelData: 'Խմբագրել {{label}} տվյալները',
    editLink: 'Խմբագրել հղումը',
    editRelationship: 'Խմբագրել հարաբերությունը',
    enterURL: 'Մուտքագրեք URL',
    internalLink: 'Ներքին հղում',
    itemsAndMore: '{{items}} և {{count}} ավելին',
    labelRelationship: '{{label}} հարաբերություն',
    latitude: 'Լայնություն',
    linkedTo: 'Կապված է <0>{{label}}</0>-ի հետ',
    linkType: 'Հղման տեսակ',
    longitude: 'Երկայնություն',
    newLabel: 'Նոր {{label}}',
    openInNewTab: 'Բացել նոր ներդիրում',
    passwordsDoNotMatch: 'Գաղտնաբառերը չեն համընկնում։',
    relatedDocument: 'Հարակից փաստաթուղթ',
    relationTo: 'Հարաբերվում է...',
    removeRelationship: 'Հեռացնել հարաբերությունը',
    removeUpload: 'Հեռացնել վերբեռնվածը',
    saveChanges: 'Պահպանել փոփոխությունները',
    searchForBlock: 'Որոնել բլոկ',
    selectExistingLabel: 'Ընտրել գոյություն ունեցող {{label}}',
    selectFieldsToEdit: 'Ընտրեք դաշտեր խմբագրման համար',
    showAll: 'Ցուցադրել բոլորը',
    swapRelationship: 'Փոխել հարաբերությունը',
    swapUpload: 'Փոխել վերբեռնվածը',
    textToDisplay: 'Ցուցադրվող տեքստ',
    toggleBlock: 'Միացնել/անջատել բլոկը',
    uploadNewLabel: 'Վերբեռնել նոր {{label}}',
  },
  folder: {
    browseByFolder: 'Թվարկել թղթապանակներով',
    byFolder: 'ըստ թղթապանակի',
    deleteFolder: 'Ջնջել թղթապանակը',
    folderName: 'Տեսակավորման անվանում',
    folders: 'Պատուհաններ',
    folderTypeDescription:
      'Ընտրեք, թե որն է հավաքածուի փաստաթղթերը, որոնք պետք է թույլատրվեն այս պանակում:',
    itemHasBeenMoved: '{{title}}-ը տեղափոխվել է {{folderName}}-ում',
    itemHasBeenMovedToRoot: '«{{title}}» տեղափոխվել է արմատային պանակ։',
    itemsMovedToFolder: '{{title}} տեղափոխվեց {{folderName}}',
    itemsMovedToRoot: '{{title}} տեղափոխվել է արմատ թղթապանակին',
    moveFolder: 'Տեղափոխել թղթապանակը',
    moveItemsToFolderConfirmation:
      'Դուք պատրաստ եք <1>{{count}} {{label}}</1> տեղափոխել <2>{{toFolder}}</2>։ Ամբողջականում համոզված եք:',
    moveItemsToRootConfirmation:
      'Դուք պատրաստված եք տեղափոխել <1>{{count}} {{label}}</1> արմատ թղթապանակի. Համոզվա՞ծ եք:',
    moveItemToFolderConfirmation:
      'Դուք պատրաստ եք տեղափոխել <1>{{title}}</1> <2>{{toFolder}}</2>։ Վստահ եք:',
    moveItemToRootConfirmation:
      'Դուք պատրաստ եք <1>{{title}}</1> տեղափոխել արմատային պանակի մեջ։ Վստահ եք։',
    movingFromFolder: '{{title}}-ի տեղափոխում {{fromFolder}}-ից',
    newFolder: 'Նոր թղթապանակ',
    noFolder: 'Ոչ մի թղթապանակ',
    renameFolder: 'Վերանվանել թղթապանակը',
    searchByNameInFolder: 'Փնտրել ըստ անվանումի {{folderName}} թղթապանակում',
    selectFolderForItem: 'Ընտրեք թղթապանակ {{title}}-ի համար',
  },
  general: {
    name: 'Անուն',
    aboutToDelete: 'Դուք պատրաստվում եք ջնջել {{label}} <1>{{title}}</1>-ը։ Համոզվա՞ծ եք։',
    aboutToDeleteCount_many: 'Դուք պատրաստվում եք ջնջել {{count}} {{label}}',
    aboutToDeleteCount_one: 'Դուք պատրաստվում եք ջնջել {{count}} {{label}}',
    aboutToDeleteCount_other: 'Դուք պատրաստվում եք ջնջել {{count}} {{label}}',
    aboutToPermanentlyDelete:
      'Դուք պատրաստ եք հաստատականորեն ջնջել {{label}} <1>{{title}}</1>։ Արդյոք վստահ եք:',
    aboutToPermanentlyDeleteTrash:
      'Դուք պատրաստ եք ընդմիշտ ջնջել <0>{{count}}</0> <1>{{label}}</1> աղբավաղուց։ Վստահ եք։',
    aboutToRestore: 'Մոտեցել եք {{label}} <1>{{title}}</1> վերականգնելուն։ Համոզված ե՞ք։',
    aboutToRestoreAsDraft:
      'Ձեր մտադրությունը վերականգնել է {{label}} <1>{{title}}</1> նախագծի որպես: Վստահ եք:',
    aboutToRestoreAsDraftCount: 'Դուք պատրաստ եք վերականգնել {{count}} {{label}} նախագծի որպես',
    aboutToRestoreCount: 'Դուք պատրաստ եք վերականգնել {{count}} {{label}}',
    aboutToTrash: 'Դուք պատրաստ եք տեղափոխել {{label}} <1>{{title}}</1>-ը աղբականջը։ Վստահ եք։',
    aboutToTrashCount: 'Դուք պատրաստ եք տեղափոխել {{count}} {{label}} աղբամանը',
    addBelow: 'Ավելացնել ներքևում',
    addFilter: 'Ավելացնել ֆիլտր',
    adminTheme: 'Կառավարման թեմա',
    all: 'Բոլորը',
    allCollections: 'Բոլոր հավաքածուները',
    allLocales: 'Բոլոր տեղայինությունները',
    and: 'Եվ',
    anotherUser: 'Այլ օգտատեր',
    anotherUserTakenOver: 'Այլ օգտատեր ստանձել է այս փաստաթղթի խմբագրումը։',
    applyChanges: 'Կիրառել փոփոխությունները',
    ascending: 'Աճող',
    automatic: 'Ավտոմատ',
    backToDashboard: 'Վերադառնալ վահանակ',
    cancel: 'Չեղարկել',
    changesNotSaved:
      'Ձեր փոփոխությունները չեն պահպանվել։ Եթե հիմա հեռանաք, կկորցնեք չպահպանված փոփոխությունները։',
    clear:
      'Հիմնական տեքստի իմաստը պետք է պահպանվի Payload կոնտեքստի մեջ: Այս այս այստեղ են հաճախակի',
    clearAll: 'Մաքրել բոլորը',
    close: 'Փակել',
    collapse: 'Փակել',
    collections: 'Հավաքածուներ',
    columns: 'Սյունակներ',
    columnToSort: 'Սյունակ՝ տեսակավորման համար',
    confirm: 'Հաստատել',
    confirmCopy: 'Հաստատել պատճենումը',
    confirmDeletion: 'Հաստատել ջնջելը',
    confirmDuplication: 'Հաստատել կրկնօրինակումը',
    confirmMove: 'Հաստատեք տեղափոխումը',
    confirmReindex: 'Վերաինդեքսավորե՞լ բոլոր {{collections}}-ը։',
    confirmReindexAll: 'Վերաինդեքսավորե՞լ բոլոր հավաքածուները։',
    confirmReindexDescription:
      'Սա կհեռացնի գոյություն ունեցող ինդեքսները և կվերաինդեքսավորի փաստաթղթերը {{collections}} հավաքածուներում։',
    confirmReindexDescriptionAll:
      'Սա կհեռացնի գոյություն ունեցող ինդեքսները և կվերաինդեքսավորի փաստաթղթերը բոլոր հավաքածուներում։',
    confirmRestoration: 'Հաստատեք վերականգնումը',
    copied: 'Պատճենված',
    copy: 'Պատճենել',
    copyField: 'Պատճենել դաշտը',
    copying: 'Պատճենվում է',
    copyRow: 'Պատճենել տողը',
    copyWarning:
      'Դուք պատրաստվում եք վերագրել {{to}}-ը {{from}}-ով {{label}} {{title}}-ի համար։ Համոզվա՞ծ եք։',
    create: 'Ստեղծել',
    created: 'Ստեղծված',
    createdAt: 'Ստեղծման ժամանակ',
    createNew: 'Ստեղծել նոր',
    createNewLabel: 'Ստեղծել նոր {{label}}',
    creating: 'Ստեղծվում է',
    creatingNewLabel: 'Ստեղծվում է նոր {{label}}',
    currentlyEditing:
      'ներկայումս խմբագրում է այս փաստաթուղթը։ Եթե Դուք ստանձնեք վերահսկողությունը, նա չի կարողանա շարունակել խմբագրումը և կարող է կորցնել չպահպանված փոփոխությունները։',
    custom: 'Հատուկ',
    dark: 'Մուգ',
    dashboard: 'Վահանակ',
    delete: 'Ջնջել',
    deleted: 'Ջնջված',
    deletedAt: 'Ջնջված է',
    deletedCountSuccessfully: '{{count}} {{label}} հաջողությամբ ջնջված է։',
    deletedSuccessfully: 'Հաջողությամբ ջնջված է։',
    deleteLabel: 'Ջնջել {{label}}',
    deletePermanently: 'Բաց թողեք աղբատուփը և հեռացրեք հավերժ:',
    deleting: 'Ջնջվում է...',
    depth: 'Խորություն',
    descending: 'Նվազող',
    deselectAllRows: 'Հանել բոլոր տողերի ընտրությունը',
    document: 'Փաստաթուղթ',
    documentIsTrashed: 'Այս {{label}}-ն աղբարկղած է և հասանելի է միայն ընթերցման համար։',
    documentLocked: 'Փաստաթուղթը կողպված է',
    documents: 'Փաստաթղթեր',
    duplicate: 'Կրկնօրինակել',
    duplicateWithoutSaving: 'Կրկնօրինակել առանց փոփոխությունները պահպանելու',
    edit: 'Խմբագրել',
    editAll: 'Խմբագրել բոլորը',
    editedSince: 'Խմբագրվել է սկսած',
    editing: 'Խմբագրում',
    editingLabel_many: 'Խմբագրվում է {{count}} {{label}}',
    editingLabel_one: 'Խմբագրվում է {{count}} {{label}}',
    editingLabel_other: 'Խմբագրվում է {{count}} {{label}}',
    editingTakenOver: 'Խմբագրումը ստանձնել է ուրիշ օգտատեր',
    editLabel: 'Խմբագրել {{label}}',
    email: 'Էլ. փոստ',
    emailAddress: 'Էլ. փոստի հասցե',
    emptyTrash: 'Մաքրել աղբաղեցույցը',
    emptyTrashLabel: 'Դատարկել {{label}} աղբուկը',
    enterAValue: 'Մուտքագրեք արժեք',
    error: 'Սխալ',
    errors: 'Սխալներ',
    exitLivePreview: 'Դուրս գալ Live Preview-ից',
    export: 'Արտարժույթ',
    fallbackToDefaultLocale: 'Վերադառնալ լռելյայն լոկալին',
    false: 'Կեղծ',
    filter: 'Ֆիլտր',
    filters: 'Ֆիլտրեր',
    filterWhere: 'Ֆիլտրել {{label}}-ը, որտեղ',
    globals: 'Համընդհանուրներ',
    goBack: 'Հետ գնալ',
    groupByLabel: 'Խմբավորել {{label}}-ով',
    import: 'Ներմուծում',
    isEditing: 'խմբագրում է',
    item: 'տարր',
    items: 'տեսականի',
    language: 'Լեզու',
    lastModified: 'Վերջին փոփոխություն',
    leaveAnyway: 'Այնուամենայնիվ հեռանալ',
    leaveWithoutSaving: 'Հեռանալ առանց պահպանելու',
    light: 'Լուսավոր',
    livePreview: 'Լայվ նախադիտում',
    loading: 'Բեռնում',
    locale: 'Լոկալ',
    locales: 'Լոկալներ',
    menu: 'Մենյու',
    moreOptions: 'Լրացուցիչ ընտրանքներ',
    move: 'Տեղափոխվել',
    moveConfirm:
      'Դուք պատրաստ եք տեղափոխել {{count}} {{label}} -ը <1>{{destination}}</1> -ից։ Արդյո՞ք վստահ եք։',
    moveCount: 'Տեղափոխել {{count}} {{label}}',
    moveDown: 'Տեղափոխել ներքև',
    moveUp: 'Տեղափոխել վերև',
    moving: 'Տեղափոխվում',
    movingCount: 'Տեղափոխվում է {{count}} {{label}}',
    newLabel: 'Նոր {{label}}',
    newPassword: 'Նոր գաղտնաբառ',
    next: 'Հաջորդ',
    no: 'Ոչ',
    noDateSelected: 'Չկա ընտրված ամսաթիվ',
    noFiltersSet: 'Ֆիլտրեր սահմանված չեն',
    noLabel: '<Չկա {{label}}>',
    none: 'Ոչ մեկը',
    noOptions: 'Ընտրանքներ չկան',
    noResults:
      '{{label}}-ը չի գտնվել։ Կա՛մ դեռևս {{label}} չկա, կա՛մ ոչ մեկը չի համապատասխանում վերևում նշված ֆիլտրերին։',
    notFound: 'Չի գտնվել',
    nothingFound: 'Ոչինչ չի գտնվել',
    noTrashResults: 'Ոչ մի {{label}} աղբարկղում:',
    noUpcomingEventsScheduled: 'Իրադարձություններ նախատեսված չեն։',
    noValue: 'Արժեք չկա',
    of: 'ի',
    only: 'Միայն',
    open: 'Բացել',
    or: 'Կամ',
    order: 'Հերթականություն',
    overwriteExistingData: 'Վերագրել գոյություն ունեցող դաշտի տվյալները',
    pageNotFound: 'Էջը չի գտնվել',
    password: 'Գաղտնաբառ',
    pasteField: 'Տեղադրել դաշտը',
    pasteRow: 'Տեղադրել տողը',
    payloadSettings: 'Payload-ի կարգավորումներ',
    permanentlyDelete: 'Մշտականությամբ Ջնջել',
    permanentlyDeletedCountSuccessfully: '{{count}} {{label}}-ը հաստատապես ջնջվել է հաջողակ:',
    perPage: 'Էջում՝ {{limit}}',
    previous: 'Նախորդ',
    reindex: 'Վերաինդեքսավորել',
    reindexingAll: 'Վերաինդեքսավորվում են բոլոր {{collections}}-ները։',
    remove: 'Հեռացնել',
    rename: 'Վերանվանել',
    reset: 'Վերակայել',
    resetPreferences: 'Վերակայել նախընտրությունները',
    resetPreferencesDescription:
      'Սա կվերակայի Ձեր բոլոր նախընտրությունները դեպի լռելյայն կարգավորումներ։',
    resettingPreferences: 'Նախընտրությունները վերակայվում են',
    restore: 'Վերականգնել',
    restoreAsPublished: 'Վերականգնել որպես հրատարակված տարբերակ',
    restoredCountSuccessfully: '{{count}} {{label}} հաջողությամբ վերականգնվեց:',
    restoring:
      'Payload-i original teksti mijocov achqers, nran avelacnum e urish Payload nshanakutyunner, oronq kangnvec en specifik texer:\n\n- Zuygh: Zuygh e ayd dokumnerneri jmum, oronq kanen arden mek ban u zoracnum en Payload-i nersum u bavararum.\n- Dasht: Dasht e ayd zuyghi bnutyun dokumneri mej. Dashter pahpanum en bnutyunneri banakanutyuny u texy, ete oronq sa patrastvi dokumentnerum.\n- Dokument: Dokument e mi',
    row: 'Տող',
    rows: 'Տողեր',
    save: 'Պահպանել',
    saving: 'Պահպանվում է...',
    schedulePublishFor: 'Հրապարակման ժամանակ նշանակել {{title}}-ի համար',
    searchBy: 'Որոնել ըստ {{label}}-ի',
    select: 'Ընտրել',
    selectAll: 'Ընտրել բոլոր {{count}} {{label}}',
    selectAllRows: 'Ընտրել բոլոր տողերը',
    selectedCount: '{{count}} {{label}} ընտրված է',
    selectLabel: 'ընտրել {{label}}',
    selectValue: 'Ընտրեք արժեք',
    showAllLabel: 'Ցուցադրել բոլոր {{label}}-ները',
    sorryNotFound: 'Ներողություն, Ձեր հարցմանը համապատասխան ոչինչ չկա։',
    sort: 'Տեսակավորել',
    sortByLabelDirection: 'Տեսակավորել ըստ {{label}} {{direction}}',
    stayOnThisPage: 'Մնալ այս էջում',
    submissionSuccessful: 'Հայտը հաջողությամբ ուղարկվել է։',
    submit: 'Հաստատել',
    submitting: 'Ուղարկվում է...',
    success: 'Հաջողված է',
    successfullyCreated: '{{label}} հաջողությամբ ստեղծվել է։',
    successfullyDuplicated: '{{label}} հաջողությամբ կրկնօրինակվել է։',
    successfullyReindexed:
      'Հաջողությամբ վերաինդեքսավորվել են {{count}}-ը {{total}} փաստաթղթերից {{collections}}-ում',
    takeOver: 'Վերցնել վերահսկողությունը',
    thisLanguage: 'Հայերեն',
    time: 'Ժամ',
    timezone: 'Ժամային գոտի',
    titleDeleted: '{{label}} "{{title}}" հաջողությամբ ջնջվել է։',
    titleRestored: '"{{label}}" "{{title}}" հաջողությամբ վերականգնվել է։',
    titleTrashed: '«{{label}}» «{{title}}» տեղափոխվել է աղբարկղում:',
    trash: 'աղբ',
    trashedCountSuccessfully: '{{count}} {{label}} տեղափոխվել է աղբարկղում։',
    true: 'Ճիշտ',
    unauthorized: 'Չթույլատրված',
    unsavedChanges:
      'Դուք ունեք չպահպանված փոփոխություններ։ Պահպանեք կամ հեռացեք նախքան շարունակելը։',
    unsavedChangesDuplicate:
      'Դուք ունեք չպահպանված փոփոխություններ։ Ցանկանու՞մ եք շարունակել կրկնօրինակումը։',
    untitled: 'Անվերնագիր',
    upcomingEvents: 'Սպասվող իրադարձություններ',
    updatedAt: 'Թարմացված է',
    updatedCountSuccessfully: '{{count}} {{label}} հաջողությամբ թարմացվել է։',
    updatedLabelSuccessfully: '',
    updatedSuccessfully: 'Հաջողությամբ թարմացվել է։',
    updateForEveryone: '',
    updating: 'Թարմացում',
    uploading: 'Վերբեռնվում է',
    uploadingBulk: 'Վերբեռնվում է {{current}}-ը {{total}}-ից',
    user: 'Օգտատեր',
    username: 'Օգտանուն',
    users: 'Օգտատերեր',
    value: 'Արժեք',
    viewing: 'Դիտում',
    viewReadOnly: '«Միայն կարդալու» ռեժիմ',
    welcome: 'Բարի գալուստ',
    yes: 'Այո',
  },
  localization: {
    cannotCopySameLocale: 'Հնարավոր չէ պատճենել նույն լոկալին',
    copyFrom: 'Պատճենել սկսած',
    copyFromTo: 'Պատճենվում է {{from}}-ից {{to}}',
    copyTo: 'Պատճենել դեպի',
    copyToLocale: 'Պատճենել լոկալին',
    localeToPublish: 'Հրապարակման լոկալ',
    selectLocaleToCopy: 'Ընտրեք լոկալ՝ պատճենելու համար',
  },
  operators: {
    contains: 'պարունակում է',
    equals: 'հավասար է',
    exists: 'գոյություն ունի',
    intersects: 'հատվում է',
    isGreaterThan: 'մեծ է, քան',
    isGreaterThanOrEqualTo: 'մեծ է կամ հավասար',
    isIn: 'գտնվում է',
    isLessThan: 'փոքր է, քան',
    isLessThanOrEqualTo: 'փոքր է կամ հավասար',
    isLike: 'նման է',
    isNotEqualTo: 'հավասար չէ',
    isNotIn: 'չի գտնվում',
    isNotLike: 'նման չէ',
    near: 'մոտ',
    within: 'ներսում',
  },
  upload: {
    addFile: 'Ավելացնել ֆայլ',
    addFiles: 'Ավելացնել ֆայլեր',
    bulkUpload: 'Զանգվածային վերբեռնում',
    crop: 'Կտրել',
    cropToolDescription:
      'Քաշեք ընտրված տարածքի անկյունները, նշեք նոր տարածք կամ կարգավորեք ստորև նշված արժեքները։',
    download: 'Ներբեռնել',
    dragAndDrop: 'Քաշեք և գցեք ֆայլը',
    dragAndDropHere: 'կամ քաշեք և գցեք ֆայլն այստեղ',
    editImage: 'Խմբագրել պատկերը',
    fileName: 'Ֆայլի անուն',
    fileSize: 'Ֆայլի չափ',
    filesToUpload: 'Վերբեռնման ֆայլեր',
    fileToUpload: 'Վերբեռնման ֆայլ',
    focalPoint: 'Կիզակետ',
    focalPointDescription:
      'Քաշեք կիզակետը անմիջապես նախադիտման վրա կամ կարգավորեք ստորև նշված արժեքները։',
    height: 'Բարձրություն',
    lessInfo: 'Ավելի քիչ տեղեկություն',
    moreInfo: 'Ավելի շատ տեղեկություն',
    noFile: 'Ֆայլ չկա',
    pasteURL: 'Տեղադրել URL',
    previewSizes: 'Նախադիտման չափեր',
    selectCollectionToBrowse: 'Ընտրեք հավաքածու՝ դիտելու համար',
    selectFile: 'Ընտրեք ֆայլ',
    setCropArea: 'Սահմանել կտրվող տարածքի չափը',
    setFocalPoint: 'Սահմանել կիզակետ',
    sizes: 'Չափեր',
    sizesFor: 'Չափեր {{label}}-ի համար',
    width: 'Լայնություն',
  },
  validation: {
    emailAddress: 'Խնդրում ենք մուտքագրել վավեր էլ. փոստի հասցե։',
    enterNumber: 'Խնդրում ենք մուտքագրել վավեր հեռախոսահամար։',
    fieldHasNo: 'Այս դաշտում {{label}} չկա',
    greaterThanMax: '{{value}}-ը մեծ է {{max}} {{label}}-ի թույլատրելի առավելագույնից։',
    invalidInput: 'Ներմուծված արժեքն անվավեր է',
    invalidSelection: 'Այս դաշտն ունի անվավեր ընտրություն։',
    invalidSelections: 'Այս դաշտն ունի հետևյալ անվավեր ընտրությունները։',
    lessThanMin: '{{value}}-ը փոքր է {{min}} {{label}}-ի թույլատրելի նվազագույն արժեքից։',
    limitReached:
      'Դու հասել եք առավելագույն սահմանին, կարող են ավելացվել միայն {{max}} քանակի տարրեր։',
    longerThanMin:
      'Այս արժեքը պետք է ավելի երկար լինի, քան {{minLength}} նիշերի նվազագույն երկարությունը։',
    notValidDate: '"{{value}}"-ը վավեր ամսաթիվ չէ։',
    required: 'Այս դաշտը պարտադիր է։',
    requiresAtLeast: 'Այս դաշտը պահանջում է առնվազն {{count}} {{label}}։',
    requiresNoMoreThan: 'Այս դաշտը պահանջում է ոչ ավելի, քան {{count}} {{label}}։',
    requiresTwoNumbers: 'Այս դաշտը պահանջում է երկու թիվ։',
    shorterThanMax:
      'Այս արժեքը պետք է ավելի կարճ լինի, քան {{maxLength}} նիշերի առավելագույն երկարությունը։',
    timezoneRequired: 'Ժամային գոտին պարտադիր է։',
    trueOrFalse: 'Այս դաշտի արժեքը կարող է միայն «ճիշտ» կամ «սխալ»։',
    username:
      'Խնդրում ենք մուտքագրել վավեր օգտանուն։ Կարող է պարունակել տառեր, թվեր, գծիկներ, կետեր և ընդգծում։',
    validUploadID: 'Այս դաշտը վավեր վերբեռնման ID չի պարունակում։',
  },
  version: {
    type: 'Տեսակ',
    aboutToPublishSelection:
      'Դուք պատրաստվում եք հրապարակել ընտրության մեջ գտնվող բոլոր {{label}}-ները։ Համոզվա՞ծ եք։',
    aboutToRestore:
      'Դուք պատրաստվում եք վերականգնել այս {{label}}-ի փաստաթուղթը {{versionDate}}-ի ժամանակ եղած վիճակին։',
    aboutToRestoreGlobal:
      'Դուք պատրաստվում եք վերականգնել համընդհանուր {{label}}-ը {{versionDate}}-ի ժամանակ եղած վիճակին։',
    aboutToRevertToPublished:
      'Դուք պատրաստվում եք հետ բերել այս փաստաթղթի փոփոխությունները դեպի իր հրապարակված վիճակին։ Համոզվա՞ծ եք։',
    aboutToUnpublish:
      'Դուք պատրաստվում եք այս փաստաթուղթը բերել չհրապարակված վիճակի։ Համոզվա՞ծ եք։',
    aboutToUnpublishSelection:
      'Դուք պատրաստվում եք ընտրության մեջ գտնվող բոլոր {{label}}-ները բերել չհրապարակված վիճակի։ Համոզվա՞ծ եք։',
    autosave: 'Ինքնապահպանում',
    autosavedSuccessfully: 'Հաջողությամբ ինքնապահպանվել է։',
    autosavedVersion: 'Ինքնապահպանված տարբերակ',
    changed: 'Փոփոխված',
    changedFieldsCount_one: '{{count}} փոփոխված դաշտ',
    changedFieldsCount_other: '{{count}} փոփոխված դաշտեր',
    compareVersion: 'Համեմատել տարբերակը հետևյալի հետ՝',
    compareVersions: 'Համեմատել տարբերակները',
    comparingAgainst: 'Համեմատել հետևյալի հետ',
    confirmPublish: 'Հաստատել հրապարակումը',
    confirmRevertToSaved: 'Հաստատել վերադարձը պահպանված վիճակին',
    confirmUnpublish: 'Հաստատել վերադարձը չհրապարակված վիճակին։',
    confirmVersionRestoration: 'Հաստատել տարբերակի վերականգնումը',
    currentDocumentStatus: 'Ընթացիկ {{docStatus}} փաստաթուղթ',
    currentDraft: 'Ընթացիկ սևագիր',
    currentlyPublished: 'Ներկայումս հրատարակված',
    currentlyViewing: 'Ներկայումս դիտում է',
    currentPublishedVersion: 'Ընթացիկ հրապարակված տարբերակ',
    draft: 'Սևագիր',
    draftSavedSuccessfully: 'Սևագիրը հաջողությամբ պահպանվել է։',
    lastSavedAgo: 'Վերջին անգամ պահպանվել է {{distance}} առաջ',
    modifiedOnly: 'Միայն փոփոխված',
    moreVersions: 'Ավելի շատ տարբերակներ...',
    noFurtherVersionsFound: 'Այլ տարբերակներ չեն գտնվել',
    noRowsFound: ' Ոչ մի {{label}} չի գտնվել',
    noRowsSelected: 'Ոչ մի {{label}} ընտրված չէ',
    preview: 'Նախադիտում',
    previouslyDraft: 'Նախկինում Սևագիր',
    previouslyPublished: 'Նախկինում հրապարակված',
    previousVersion: 'Նախորդ Տարբերակ',
    problemRestoringVersion: 'Այս տարբերակը վերականգնելու ժամանակ խնդիր է առաջացել',
    publish: 'Հրապարակել',
    publishAllLocales: 'Հրապարակել բոլոր լոկալներում',
    publishChanges: 'Հրապարակել փոփոխությունները',
    published: 'Հրապարակված',
    publishIn: 'Հրապարակել {{locale}}-ում',
    publishing: 'Հրապարակվում է',
    restoreAsDraft: 'Վերականգնել որպես սևագիր',
    restoredSuccessfully: 'Հաջողությամբ վերականգնված։',
    restoreThisVersion: 'Վերականգնել այս տարբերակը',
    restoring: 'Վերականգնվում է...',
    reverting: 'Հետ է բերվում...',
    revertToPublished: 'Հետ բերել հրապարակված վիճակին',
    saveDraft: 'Պահպանել սևագիրը',
    scheduledSuccessfully: 'Հաջողությամբ պլանավորված։',
    schedulePublish: 'Պլանավորել հրապարակումը',
    selectLocales: 'Ընտրեք ցուցադրման լոկալները',
    selectVersionToCompare: 'Ընտրեք տարբերակ՝ համեմատելու համար',
    showingVersionsFor: 'Ցուցադրված են տարբերակները՝',
    showLocales: 'Ցուցադրել լոկալները՝',
    specificVersion: 'Մասնավոր Տարբերակ',
    status: 'Կարգավիճակ',
    unpublish: 'Բերել չհրապարակված վիճակի։',
    unpublishing: 'Բերվում է չհրապարակված վիճակի...',
    version: 'Տարբերակ',
    versionAgo: '{{distance}} առաջ',
    versionCount_many: 'Գտնվել են {{count}} տարբերակներ',
    versionCount_none: 'Ոչ մի տարբերակ չի գտնվել',
    versionCount_one: '{{count}} տարբերակ է գտնվել',
    versionCount_other: '{{count}} տարբերակ է գտնվել',
    versionID: 'Տարբերակի ID',
    versions: 'Տարբերակներ',
    viewingVersion: 'Ցույց է տրված {{entityLabel}} {{documentTitle}}-ի տարբերակը',
    viewingVersionGlobal: 'Ցույց է տրված համընդհանուր {{entityLabel}}-ի տարբերակը',
    viewingVersions: 'Ցույց է տրված {{entityLabel}} {{documentTitle}}-ի տարբերակները',
    viewingVersionsGlobal: 'Ցույց է տրված համընդհանուր {{entityLabel}}-ի տարբերակները',
  },
}

export const hy: Language = {
  dateFNSKey: 'hy-AM',
  translations: hyTranslations,
}
